import React, { useState } from "react";
import { X } from "lucide-react";

const CarrierPeopleSection = ({
  formValues,
  setValue
}) => {
  // Temporary form state for adding new person
  const [tempPerson, setTempPerson] = useState({
    type: 'driver',
    fullName: '',
    email: '',
    phoneNumber: ''
  });

  // Handle input changes
  const handleInputChange = (field, value) => {
    setTempPerson(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleAddPerson = () => {
    const fullName = tempPerson.fullName.trim();
    
    if (fullName) {
      const newPerson = {
        type: tempPerson.type || 'driver',
        fullName: fullName,
        email: tempPerson.email.trim() || '',
        phoneNumber: tempPerson.phoneNumber.trim() || ''
      };
      setValue('people', [...(formValues.people || []), newPerson]);
      
      // Reset temp form
      setTempPerson({
        type: 'driver',
        fullName: '',
        email: '',
        phoneNumber: ''
      });
    }
  };

  const handleRemovePerson = (index) => {
    const newPeople = (formValues.people || []).filter((_, i) => i !== index);
    setValue('people', newPeople);
  };

  const people = Array.isArray(formValues.people) 
    ? formValues.people.filter(person => person && person.fullName)
    : [];

  return (
    <div className="form-section">
      <span className="section-title">People</span>
      <div className="form-field">
        <label className="form-label">
          Add people (drivers/dispatchers) for this carrier (optional)
        </label>
        
        {people.length > 0 && (
          <div className="selected-items-list selected-items-list--with-margin">
            {people.map((person, index) => {
              const fullName = person.fullName || '';
              const type = person.type || 'driver';
              const email = person.email || '';
              const phoneNumber = person.phoneNumber || '';
              
              return (
                <div key={`person-${index}-${fullName}`} className="selected-item-tag">
                  <span>
                    <strong>{type === 'driver' ? 'Driver' : 'Dispatcher'}:</strong> {fullName}
                    {email && ` - ${email}`}
                    {phoneNumber && ` - ${phoneNumber}`}
                  </span>
                  <button
                    type="button"
                    className="remove-tag-button"
                    onClick={() => handleRemovePerson(index)}
                  >
                    <X size={14} />
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <div className="add-person-form">
          <h4 className="add-person-form__title">Add New Person</h4>
          <div className="add-person-form__fields">
            <div className="form-field">
              <label htmlFor="carrierPersonType" className="form-label">Type *</label>
              <select
                id="carrierPersonType"
                className="form-select"
                value={tempPerson.type}
                onChange={(e) => handleInputChange('type', e.target.value)}
              >
                <option value="driver">Driver</option>
                <option value="dispatcher">Dispatcher</option>
              </select>
            </div>
            <div className="form-field">
              <label htmlFor="carrierPersonFullName" className="form-label">Full Name *</label>
              <input
                type="text"
                placeholder="Full Name"
                id="carrierPersonFullName"
                className="form-input"
                value={tempPerson.fullName}
                onChange={(e) => handleInputChange('fullName', e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddPerson();
                  }
                }}
              />
            </div>
            <div className="form-field">
              <label htmlFor="carrierPersonEmail" className="form-label">Email</label>
              <input
                type="email"
                placeholder="email@example.com"
                id="carrierPersonEmail"
                className="form-input"
                value={tempPerson.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
              />
            </div>
            <div className="form-field">
              <label htmlFor="carrierPersonPhone" className="form-label">Phone Number</label>
              <input
                type="tel"
                placeholder="Phone Number"
                id="carrierPersonPhone"
                className="form-input"
                value={tempPerson.phoneNumber}
                onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
              />
            </div>
            <button
              type="button"
              onClick={handleAddPerson}
              className="add-person-form__button"
            >
              Add Person
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarrierPeopleSection;

